import { render, staticRenderFns } from "./modifier-scheme-translation-list.vue?vue&type=template&id=0743c09a&scoped=true"
import script from "./modifier-scheme-translation-list.vue?vue&type=script&lang=js"
export * from "./modifier-scheme-translation-list.vue?vue&type=script&lang=js"
import style0 from "./modifier-scheme-translation-list.vue?vue&type=style&index=0&id=0743c09a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0743c09a",
  null
  
)

export default component.exports